import {FormGroup} from '@angular/forms';
import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, QueryList, ViewChildren} from '@angular/core';
import {IdHelper} from '../../helper/id.helper';
import {DatevMessagePathDirective, DatevMessageService} from '@datev/ngx-ui-components';
import {cloneDeep} from 'lodash';
import {Subscription} from 'rxjs';

@Component({template: ''})
export abstract class FormBaseComponent<T> implements OnInit, OnDestroy, AfterViewInit {

    @ViewChildren(DatevMessagePathDirective)
    public allDatevMessagePaths: QueryList<DatevMessagePathDirective>;
    @Output()
    public dataChange: EventEmitter<T> = new EventEmitter<T>();
    @Input()
    public index: number;
    @Input()
    public readonly;

    // Hilfsfkt. für HTML
    public enumKeys = Object.keys;
    public form: FormGroup;
    public valueChangeSubscription: Subscription;
    public objectId: string = IdHelper.generateRandomString(24);
    private internalData: T;

    protected constructor(protected readonly messageService: DatevMessageService) {
    }

    public get data(): T {
        return this.internalData;
    }

    @Input()
    public set data(data: T) {
        this.internalData = data;
        if (this.form) {
            this.resetFormData(cloneDeep(data));
        }
    }

    public ngOnInit(): void {
        if (this.data === null || this.data === undefined) {
            this.data = {} as T;
        }
        this.createForm();
        this.valueChangeSubscription = this.form.valueChanges.subscribe((value: unknown) => {
            if (this.data) {
                Object.assign(this.data, value);
                this.dataChange.emit(this.data);
            }
        });
    }

    public ngAfterViewInit(): void {
        setTimeout(() => {
            // Um zu verhindern, dass die Form disabled wird bevor alle Kindelemente gerendert wurden
            if (this.readonly) {
                this.form.disable();
            }
        });
    }

    public ngOnDestroy(): void {
        this.allDatevMessagePaths.forEach((item: DatevMessagePathDirective) => {
            // notwendig, damit keine Messages "hängen" bleiben und später zu einer ExpressionChanged Exception führen,
            // falls die Komponente ein/ausgeblendet wird
            this.messageService.clearMessages(item.datevMessagePath);
        });
        this.valueChangeSubscription.unsubscribe();
    }

    private resetFormData(data: T): void {
        if (data) {
            Object.keys(this.form.value).forEach((key: string) => {
                this.form.get(key).setValue(null);
            });
            this.form.patchValue(data);
            this.form.updateValueAndValidity();
        }
    }

    protected abstract createForm(): void;

}
